import controller from './auth.controller';

let AuthComponent = {
  template:'',
  controller,
  bindings : {
    shCtrl : '<'
  }
};

export default AuthComponent





// WEBPACK FOOTER //
// ./www/components/auth/auth.component.js